export default function CSyllabus() {
  return <h2>C Syllabus</h2>;
}
